import Vue from 'vue'

// Core
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Packs
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

// Add everything
library.add(fas, fal, fad, fab)

// Register the component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)